import { useEffect, useState } from "react";
import Button from "../../../components/UI/Button/Button";
import Pagination from "../../../components/UI/Table/Pagination";
import classes from "../MngCommon.module.css";
import { ReqSystemPopupList } from "../../../api/site/ApiForSystemPopup";
import { useNavigate } from "react-router-dom";
import PaginationNew from "../../../components/UI/Table/PaginationNew";
import Moment from "moment";

function MngSystemPage(props) {

    const navigate = useNavigate();

    const createHandler = () => {
        navigate("./create");
    };

    const detailHandler = (e, id) => {
        e.preventDefault();

        navigate(`./${id}`);
    };

    const [systemPopups, setSystemPopups] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0); //총 페이지 갯수
    const [totalCount, setTotalCount] = useState(0); //총 데이터 갯수

    const handlePageChange = async (page) => {
        setCurrentPage(page);

        const response = await ReqSystemPopupList(page);
        if (response.status === 200) {
            const resData = await response.data.data;
            setTotalPage(resData.totalPages);
            setTotalCount(resData.totalElements);
            setSystemPopups(resData.content);
        } else {
            setSystemPopups([]);
        }
    };
    useEffect(() => {
        handlePageChange(currentPage);
    }, [])
    return (
        <section>
            <div className={classes.admin_contents}>
                <h3>시스템 점검 안내 - 목록</h3>
                <div className={classes.contents_wrap}>
                    <div
                        className={`${classes.admin_table_wrap} ${classes.align_center}  ${classes.row_select}`}
                    >
                        <table>
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "40%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "13%" }} />
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "10%" }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>시스템 점검 일시</th>
                                    <th>사전안내 팝업</th>
                                    <th>등록일</th>
                                    <th>등록자</th>
                                    <th>사용여부</th>
                                </tr>
                            </thead>
                            <tbody>
                                {systemPopups.length !== 0 &&
                                    systemPopups.map((data, index) => (
                                        <tr
                                            onClick={(e) =>
                                                detailHandler(e, data.id)
                                            }
                                        >
                                            <td>
                                                {totalCount -
                                                    (10 * currentPage + index)}
                                            </td>
                                            <td>
                                                {Moment(
                                                    data.startDate,
                                                    "YYYYMMDDHHmm"
                                                ).format(
                                                    "YYYY-MM-DD HH:mm"
                                                )}{" "}
                                                ~{" "}
                                                {Moment(
                                                    data.endDate,
                                                    "YYYYMMDDHHmm"
                                                ).format("YYYY-MM-DD HH:mm")}
                                            </td>
                                            <td>
                                                {data.notiExposeYn
                                                    ? "노출"
                                                    : "미노출"}
                                            </td>
                                            <td>
                                                {Moment(data.regDate).format(
                                                    "YYYY-MM-DD"
                                                )}
                                            </td>
                                            <td>{data.regID}</td>
                                            <td>
                                                {data.exposeYn
                                                    ? "사용"
                                                    : "미사용"}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                        <PaginationNew
                            className="admin_st"
                            totalPage={totalPage}
                            currentPage={currentPage}
                            defaultShowPage={5}
                            changePageCB={handlePageChange}
                        />
                        <div
                            className={`${classes.bottom_btn_wrap} ${classes.position_st}`}
                        >
                            <Button
                                className="secondary sm"
                                onClick={createHandler}
                            >
                                등록
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MngSystemPage;

export const loader = async () => {
    const response = await ReqSystemPopupList(0);

    if (response.status === 200) {
        const resData = await response.data.data;
        return {
            data: resData.content,
            totalPage: resData.totalPages,
            totalCount: resData.totalElements,
        };
    } else {
        return { data: [], totalPage: 0, totalCount: 0 };
    }
};
